module.exports = __webpack_public_path__ + "static/media/blog_image_1.d63a406b.webp";